import React from 'react';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import store from '../../store';
import {
    downloadInstallmentsReport,
    downloadTransactionReport,
    downloadCardlessReport,
    getCardlessList,
    getInstallmentsList,
    getTransactionList,
} from '../../providers/authorizations';
import {getMap} from '../../providers/rest';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment';
import Loader from '../common/Loader';
import {
    getEcomAvailabilityByAfm,
    getMidsAndTidsFilteredByAfmAndMidAndEcom,
    getMidsTidsWithAliases,
    getTransactionTypesByAfm,
} from '../../providers/merchants';
import update from 'react-addons-update';
import {toggleSearchTransactionsPopover} from '../../actions/userActions';
import EmptyStateShape from '../common/EmptyStateShape';
import {filterByKeyValue, getSignedAmount} from '../../lib/utils';
import TransactionPopoverAndTable from '../transactions/TransactionPopoverAndTable';
import InstallmentPopoverAndTable from '../transactions/InstallmentPopoverAndTable';
import CardlessPopoverAndTable from "../transactions/CardlessPopoverAndTable";
import CardlessIcon from '../common/CardlessIcon';

const Translate = require('react-redux-i18n').Translate
const I18n = require('react-redux-i18n').I18n

const stateMap = (store) => {
    return {
        i18n: store.i18n,
        userReducer: store.userReducer,
        merchantReducer: store.merchantReducer
    };
};

// Transaction type configurations
const TRANSACTION_TYPES = {
    notecom: {
        key: 'notecom',
        titleKey: 'pages.transactions.tabs.store.title',
        component: TransactionPopoverAndTable,
        stateKey: 'isNoteToggleOn',
        availabilityKey: 'hasNotEcomTransactions',
        isInstallment: false,
        isCardless: false,
    },
    ecom: {
        key: 'ecom',
        titleKey: 'pages.transactions.tabs.ecommerce.title',
        component: TransactionPopoverAndTable,
        stateKey: 'isEcomToggleOn',
        availabilityKey: 'hasEcomTransactions',
        isInstallment: false,
        isCardless: false,
        additionalProps: {
            ecomTableCls: true,
            isEcom: true
        }
    },
    installments: {
        key: 'installments',
        titleKey: 'pages.transactions.tabs.installments.title',
        component: InstallmentPopoverAndTable,
        stateKey: 'isInstallmentsToggleOn',
        availabilityKey: 'isCardlinkOne',
        isInstallment: true,
        isCardless: false,
        additionalProps: {}
    },
    cardless: {
        key: 'cardless',
        titleKey: 'pages.transactions.tabs.cardless.title',
        component: CardlessPopoverAndTable,
        stateKey: 'isCardlessToggleOn',
        availabilityKey: 'hasCardless',
        isInstallment: false,
        isCardless: true,
        icon: CardlessIcon,
        additionalProps: {}
    }
};

class Transactions extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // Transaction type toggles - simplified

            toggleStates: {
                isNoteToggleOn: false,
                isEcomToggleOn: false,
                isInstallmentsToggleOn: false,
                isCardlessToggleOn: false,
            },

            // Merchant capabilities
            capabilities: {
                hasEcomTransactions: false,
                hasNotEcomTransactions: false,
                isCardlinkOne: false,
                hasCardless: false,
            },

            // User and merchant data
            userAfm: props.merchantReducer.afm ? props.merchantReducer.afm : undefined,
            selectedMid: undefined,

            // Date and time
            dateFrom: this.props.location.state ? moment(this.props.location.state.dateFrom).format('DD/MM/YYYY') :
                moment().format('DD/MM/YYYY'),
            dateTo: this.props.location.state ? moment(this.props.location.state.dateTo).format('DD/MM/YYYY') :
                moment().format('DD/MM/YYYY'),
            startTime: '00:00',
            endTime: '23:59',
            // Search and filter criteria
            paymentTypeValue: 'notecom',
            authorizationCode: null,
            merchantId: null,
            terminalId: null,
            amountFrom: null,
            amountTo: null,
            acquirerId: null,
            vMerchantId: null,
            vTerminalId: null,
            transactionType: null,
            transactionTypeLabel: null,
            successStatus: false,
            rejectStatus: false,
            packageStatus: null,
            hasClosedBatch: false,
            // Additional search fields that might be needed for API
            cardNumber: null,
            rrn: null,
            trxId: null,
            responseCode: null,
            paymentTypeLabel: null,
            acquirerTypeLabel: null,
            pickedAcquirerLabel: null,

            // Cardless specific fields
            source: '',
            sourceLabel: I18n.t('pages.transactions.searchModal.cardless.allSourcesLabel'),
            paymentRespMessage: '',
            paymentRespMsgLabel: I18n.t('pages.transactions.searchModal.cardless.allPaymentRespMsgsLabel'),

            // Table data and pagination
            tableData: [],
            installmentsTableData: [],
            cardlessTableData: [],
            allMaps: null,
            currentPage: 1,
            asc: false,
            by: "authorizationDate,authorizationTime",
            showDuplicateTransactions: false,
            rowsPerPage: 20,
            total: null,

            // UI state
            moreCriteria: false,
            loaderSquircleIsActive: false,
            transactionReportError: null,
            searchStartedFromPopoverSearch: false,

            // Dropdown data
            allStoresBaseMid: I18n.t('pages.transactions.searchModal.midColumn.allStores'),
            allPosBaseTid: I18n.t('pages.transactions.searchModal.midColumn.allPos'),
            allPosBaseVmid: I18n.t('pages.transactions.searchModal.lowerMidColumn.allVmids'),
            allPosBaseVtid: I18n.t('pages.transactions.searchModal.lowerMidColumn.allVtids'),
            allAcquirersBase: I18n.t('pages.transactions.searchModal.lowerMidColumn.pickBank'), // Required when recalling after locale to change the allResultsDropdowns function
            getAssociationsResponse: null,
            // Required when recalling after locale to change the mapDataFormat function
            transactionMaps: null,
            filteredMids: undefined,
            filteredTids: undefined,
            filteredVMids: undefined,
            filteredVTids: undefined,
            initialTids: undefined,
            transactionTypesByAfm: null,
            aliasesArr: [],

            // Non-map dropdown data with safe defaults
            nonMapData: {
                midsInDropdownFormat: [],
                tidsInDropdownFormat: [],
                vMidsInDropdownFormat: [],
                vTidsInDropdownFormat: []
            },
        };

        // Bind methods
        this.bindMethods();
    }

    bindMethods() {
        this.setMerchantCapabilitiesAndInitialTab = this.setMerchantCapabilitiesAndInitialTab.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.togglePopover = this.togglePopover.bind(this);
        this.adjustTable = this.adjustTable.bind(this);
        this.adjustInstallmentsTable = this.adjustInstallmentsTable.bind(this);
        this.adjustCardlessTable = this.adjustCardlessTable.bind(this);
        this.getRequiredMaps = this.getRequiredMaps.bind(this);
        this.formatData = this.formatData.bind(this);
        this.getTransactions = this.getTransactions.bind(this);
        this.getInstallments = this.getInstallments.bind(this);
        this.getCardless = this.getCardless.bind(this);
        this.downloadTransactionsReport = this.downloadTransactionsReport.bind(this);
        this.allResultsDropdowns = this.allResultsDropdowns.bind(this);
        this.resetPopover = this.resetPopover.bind(this);
        this.hideTransactionReportError = this.hideTransactionReportError.bind(this);
        this.toggleMoreCriteria = this.toggleMoreCriteria.bind(this);
        this.getListsByAfmOrMid = this.getListsByAfmOrMid.bind(this);
        this.setSelectedMid = this.setSelectedMid.bind(this);
        this.toDropdownFormat = this.toDropdownFormat.bind(this);
        this.setAliasesArr = this.setAliasesArr.bind(this);

        // New improved methods
        this.setMerchantCapabilitiesAndInitialTab = this.setMerchantCapabilitiesAndInitialTab.bind(this);
        this.getDefaultTabKey = this.getDefaultTabKey.bind(this);
        this.getSelectedTabKey = this.getSelectedTabKey.bind(this);

        // New helper methods
        this.getAvailableTransactionTypes = this.getAvailableTransactionTypes.bind(this);
        this.calculateSearchButtonPosition = this.calculateSearchButtonPosition.bind(this);
        this.renderTransactionTab = this.renderTransactionTab.bind(this);
        this.getCommonTabProps = this.getCommonTabProps.bind(this);

    }

    componentWillMount() {
        // Don't set any capabilities yet - wait for the async ecom availability data
        // This prevents premature tab selection before all capabilities are known

        store.dispatch(getEcomAvailabilityByAfm()).then((resp) => {
            let afmParam = this.props.merchantReducer.afm ? this.props.merchantReducer.afm: null;
            this.setMerchantCapabilitiesAndInitialTab(afmParam, resp.value.data);
        });

        this.setAliasesArr(this.state.userAfm)

        if (this.state.paymentTypeValue !== 'installments') {
            this.getTransactions(
                this.state.dateFrom,
                this.state.dateTo,
                this.state.startTime,
                this.state.endTime,
                this.state.currentPage,
                this.state.rowsPerPage,
                false, this.state.by, undefined, this.state.paymentTypeValue);
        } else {
            this.getInstallments(
                this.state.trxId,
                this.state.dateFrom,
                this.state.dateTo,
                this.state.amountFrom,
                this.state.amountTo,
                this.state.currentPage,
                this.state.rowsPerPage,
                false, this.state.by, undefined);
        }        this.getRequiredMaps();

        this.allResultsDropdowns(this.props.userReducer);

        this.setState({
            getAssociationsResponse: this.props.userReducer,
            allPosBaseVmid: I18n.t('pages.transactions.searchModal.lowerMidColumn.allVmids'),
            allPosBaseVtid: I18n.t('pages.transactions.searchModal.lowerMidColumn.allVtids')
        }, () => {
            this.getListsByAfmOrMid(this.state.userAfm);
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i18n.locale !== this.props.i18n.locale) {
            const remappedCardlessTableData = this.state.cardlessTableData.map(obj => ({
                ...obj,
                paymentRespMessage: {
                    ...obj.paymentRespMessage,
                    text: obj.paymentRespMessage.code != null
                        ? I18n.t(`pages.cardless.details.statusDescription.${obj.paymentRespMessage.code}`)
                        : obj.paymentRespMessage.text
                }
            }));

            this.setState({
                allStoresBaseMid: I18n.t('pages.transactions.searchModal.midColumn.allStores'),
                allPosBaseTid: I18n.t('pages.transactions.searchModal.midColumn.allPos'),
                allPosBaseVmid: I18n.t('pages.transactions.searchModal.lowerMidColumn.allVmids'),
                allPosBaseVtid: I18n.t('pages.transactions.searchModal.lowerMidColumn.allVtids'),
                allAcquirersBase: I18n.t('pages.transactions.searchModal.lowerMidColumn.pickBank'),
                cardlessTableData: remappedCardlessTableData,
            }, () => {
                this.allResultsDropdowns(this.state.getAssociationsResponse)
            })
        }

        if (nextProps.merchantReducer.afm !== this.props.merchantReducer.afm) {
            // Use the new method instead of the old checkEcomNotEcomAvailability
            this.setMerchantCapabilitiesAndInitialTab(nextProps.merchantReducer.afm, nextProps.merchantReducer.ecomAvailability.payload)
            this.setState({
                userAfm: nextProps.merchantReducer.afm ? nextProps.merchantReducer.afm : undefined,
                // Capabilities will be updated by setMerchantCapabilitiesAndInitialTab, but keep this as backup
                capabilities: {
                    ...this.state.capabilities,
                    isCardlinkOne: nextProps.merchantReducer.isCardlinkOne ? nextProps.merchantReducer.isCardlinkOne : false,
                    hasCardless: nextProps.merchantReducer.hasCardless ? nextProps.merchantReducer.hasCardless : false,
                }
            }, () => {
                this.adjustTable(1, 20, "authorizationDate,authorizationTime");

                if (this.state.userAfm) {
                    this.getListsByAfmOrMid(this.state.userAfm ? this.state.userAfm :
                        undefined, undefined);
                } else {
                    this.setState({
                        filteredMids: undefined,
                        filteredTids: undefined
                    }, () => {
                        this.allResultsDropdowns(this.props.userReducer)
                    })
                }
            })
        }
    }

    /**
     * Get list of available transaction types based on merchant capabilities
     */
    getAvailableTransactionTypes() {
        return Object.values(TRANSACTION_TYPES).filter(type => {
            return this.state.capabilities[type.availabilityKey];
        });
    }

    /**
     * Calculate search button position based on number of available tabs
     * This replaces the complex ternary logic that was duplicated
     */
    calculateSearchButtonPosition(transactionType) {
        const availableTypes = this.getAvailableTransactionTypes();
        const tabCount = availableTypes.length;

        // Handle specific positioning for cardless, installments, and ecom
        if (transactionType) {
            if (transactionType.key === 'cardless') {
                if (tabCount > 3) {
                    return "further-right";
                } else if (tabCount === 3) {
                    return "right";
                } else if (tabCount === 2) {
                    return "middle";
                } else {
                    return "";
                }
            } else if (transactionType.key === 'installments') {
                if (tabCount > 2) {
                    return "right";
                } else if (tabCount === 2) {
                    return "middle";
                } else {
                    return "";
                }
            } else if (transactionType.key === 'ecom') {
                if (tabCount >= 2) {
                    return "middle";
                } else {
                    return "";
                }
            }
        }

        // Default positioning for other transaction types
        if (tabCount >= 3) {
            return "right";
        } else if (tabCount === 2) {
            return "middle";
        } else {
            return "";
        }
    }

    /**
     * Get common props that are shared across all transaction tab components
     */
    getCommonTabProps(transactionType) {
        const isInstallment = transactionType.isInstallment;
        const isCardless = transactionType.isCardless;

        const baseProps = {
            data: this.state,
            tableData: isInstallment ? this.state.installmentsTableData : (isCardless ? this.state.cardlessTableData : this.state.tableData),
            allMaps: this.state.allMaps,
            adjustTable: isInstallment ? this.adjustInstallmentsTable : (isCardless ? this.adjustCardlessTable : this.adjustTable),
            locale: this.props.i18n,
            isToggleOn: this.state.toggleStates[transactionType.stateKey],
            togglePopover: this.togglePopover,
            getTransactions: isInstallment ? this.getInstallments : (isCardless ? this.getCardless : this.getTransactions),
            resetPopover: this.resetPopover,
            downloadTransactionsReport: this.downloadTransactionsReport,
            transactionReportError: this.state.transactionReportError,
            hideTransactionReportError: this.hideTransactionReportError,
            authorizationReport: this.props.merchantReducer.authorizationReport,
            merchantReducer: this.props.merchantReducer,
            toggleMoreCriteria: this.toggleMoreCriteria,
            setSelectedMid: this.setSelectedMid,
            searchStartedFromPopoverSearch: this.state.searchStartedFromPopoverSearch,
            hasNotEcomTransactions: this.state.capabilities.hasNotEcomTransactions,
            transactionTypesByAfm: this.state.transactionTypesByAfm,
            showDuplicateTransactions: this.state.showDuplicateTransactions,

            // Add search button position for types that need it
            ...((['installments', 'cardless', 'ecom'].includes(transactionType.key)) && {
                searchButtonPosition: this.calculateSearchButtonPosition(transactionType)
            }),
        };

        // Add cardless-specific props
        if (isCardless) {
            // Update the data object to include cardless-specific fields and handleChange method
            baseProps.data = {
                ...baseProps.data,
                source: this.state.source,
                sourceLabel: this.state.sourceLabel,
                paymentRespMsgLabel: this.state.paymentRespMsgLabel,
                handleChange: this.handleChange
            };
            // Pass only allMaps.cardless.source as sourceMap prop
            baseProps.sourceMap = this.state.allMaps?.cardless?.source;
        }

        return {
            ...baseProps,
            // Add any additional props specific to this transaction type
            ...transactionType.additionalProps
        };
    }    /**
     * Render a single transaction tab
     */
    renderTransactionTab(transactionType) {
        const Component = transactionType.component;
        const props = this.getCommonTabProps(transactionType);
        const IconComponent = transactionType.icon;

        const title = (
            IconComponent ?
                <span>
                    <i><IconComponent /></i>
                    <Translate value={transactionType.titleKey} dangerousHTML />
                </span>:
                <Translate value={transactionType.titleKey} dangerousHTML />
        );
        return (
            <Tab
                key={transactionType.key}
                eventKey={transactionType.key}
                id={`tab-trx-content-${transactionType.key}`}
                title={title}
            >
                <Component {...props} />
            </Tab>
        );
    }

    /**
     * Set merchant capabilities and determine initial tab selection
     * This replaces the old checkEcomNotEcomAvailability and defineInitialPaymentTypeValue methods
     */
    setMerchantCapabilitiesAndInitialTab(afm, ecomData) {
        let hasEcomTransactions = true;
        let hasNotEcomTransactions = true;

        // Process ecom availability data
        ecomData.forEach(element => {
            if (!afm || afm === element.afm) {
                hasEcomTransactions = element.ecom ? element.ecom : hasEcomTransactions;
                hasNotEcomTransactions = element.notecom ? element.notecom : hasNotEcomTransactions;
            }
        });

        // Get current AFM-specific capabilities from merchantReducer
        // These are set when switching companies and should reflect the current AFM's capabilities
        const currentAfmCapabilities = {
            isCardlinkOne: this.props.merchantReducer.isCardlinkOne || false,
            hasCardless: this.props.merchantReducer.hasCardless || false,
        };

        // Update capabilities with both ecom/notecom availability and AFM-specific capabilities
        this.setState({
            capabilities: {
                ...this.state.capabilities,
                hasEcomTransactions: hasEcomTransactions,
                hasNotEcomTransactions: hasNotEcomTransactions,
                // Include AFM-specific capabilities for installments and cardless
                isCardlinkOne: currentAfmCapabilities.isCardlinkOne,
                hasCardless: currentAfmCapabilities.hasCardless,
            },
            paymentTypeValue: this.getDefaultTabKey()
        });
    }

    /**
     * Get the default tab key based on available transaction types
     */
    getDefaultTabKey() {
        const availableTypes = this.getAvailableTransactionTypes();

        // Priority order: notecom -> ecom -> installments -> cardless
        const priority = ['notecom', 'ecom', 'installments', 'cardless'];

        for (const typeKey of priority) {
            if (availableTypes.some(type => type.key === typeKey)) {
                return typeKey;
            }
        }

        // Fallback to first available or notecom
        const fallback = availableTypes.length > 0 ? availableTypes[0].key : 'notecom';
        return fallback;
    }

    /**
     * Get the selected tab key, ensuring it's valid
     */
    getSelectedTabKey() {
        const availableTypes = this.getAvailableTransactionTypes();
        const currentType = this.state.paymentTypeValue;

        // Check if current tab is available
        if (availableTypes.some(type => type.key === currentType)) {
            return currentType;
        }

        // Fallback to default
        return this.getDefaultTabKey();
    }

    resetPopover() {
        this.setState({
            toggleStates: {
                isNoteToggleOn: false,
                isEcomToggleOn: false,
                isInstallmentsToggleOn: false,
                isCardlessToggleOn: false,
            }
        });
        this.toggleMoreCriteria(false);
        store.dispatch(toggleSearchTransactionsPopover(false));
        this.getListsByAfmOrMid(this.state.userAfm ? this.state.userAfm : undefined, undefined);
    }

    togglePopover() {
        const newToggleStates = { ...this.state.toggleStates };

        // Reset all toggles first
        Object.keys(newToggleStates).forEach(key => {
            newToggleStates[key] = false;
        });
        // Set the appropriate toggle based on current payment type
        switch(this.state.paymentTypeValue) {
            case "notecom":
                newToggleStates.isNoteToggleOn = !this.state.toggleStates.isNoteToggleOn;
                break;
            case "ecom":
                newToggleStates.isEcomToggleOn = !this.state.toggleStates.isEcomToggleOn;
                break;
            case "installments":
                newToggleStates.isInstallmentsToggleOn = !this.state.toggleStates.isInstallmentsToggleOn;
                break;
            case "cardless":
                newToggleStates.isCardlessToggleOn = !this.state.toggleStates.isCardlessToggleOn;
                break;
        }

        this.setState({
            toggleStates: newToggleStates
        }, () => {
            this.toggleMoreCriteria(false);
            const anyToggleOn = Object.values(this.state.toggleStates).some(toggle => toggle);
            store.dispatch(toggleSearchTransactionsPopover(anyToggleOn));
        });
    }    setSelectedMid(mid) {
        this.setState({
            selectedMid: mid,
            searchStartedFromPopoverSearch: true
        }, () => {
            this.getListsByAfmOrMid(this.state.userAfm ? this.state.userAfm : undefined, mid ? mid.toString() : undefined)
        })
    }    async getListsByAfmOrMid(afm, mid) {
        const ecom = this.state.paymentTypeValue === 'ecom';
        if (!mid) {
            store.dispatch(getMidsAndTidsFilteredByAfmAndMidAndEcom(1, -1, afm, undefined, ecom)).then(
                (response) => {
                    this.setState({
                        filteredMids: response.value.data.midsWithLocation,
                        initialTids: response.value.data.tids
                    }, () => {
                        let midsInDropdownFormat = this.toDropdownFormat(this.state.filteredMids, 'pickedMid');
                        let initialTidsInDropdownFormat = this.toDropdownFormat(this.state.initialTids, 'pickedTid', 'allPosBaseTid');
                        this.setState({
                            nonMapData: update(this.state.nonMapData, {
                                midsInDropdownFormat: {$set: midsInDropdownFormat},
                                tidsInDropdownFormat: {$set: initialTidsInDropdownFormat}
                            }),

                        })
                    })
                },
                (error) => {
                }
            );
        } else {
            store.dispatch(getMidsAndTidsFilteredByAfmAndMidAndEcom(1, -1, afm, mid, ecom)).then(
                (response) => {
                    this.setState({
                        filteredTids: response.value.data.tids,
                        filteredVMids: response.value.data.vMids,
                        filteredVTids: response.value.data.vTids,
                    }, () => {
                        let tidsInDropdownFormat = this.toDropdownFormat(this.state.filteredTids, 'pickedTid', 'allPosBaseTid');
                        let vMidsInDropdownFormat = this.toDropdownFormat(this.state.filteredVMids, 'pickedVMid', 'allPosBaseVmid');
                        let vTidsInDropdownFormat = this.toDropdownFormat(this.state.filteredVTids, 'pickedVTid', 'allPosBaseVtid');
                        this.setState({
                            nonMapData: update(this.state.nonMapData, {
                                tidsInDropdownFormat: {$set: tidsInDropdownFormat},
                                vMidsInDropdownFormat: {$set: vMidsInDropdownFormat},
                                vTidsInDropdownFormat: {$set: vTidsInDropdownFormat},
                            }),
                            searchStartedFromPopoverSearch: false
                        })
                    })
                },
                (error) => {
                }
            );
        }

        store.dispatch(getTransactionTypesByAfm(afm)).then((response) => {
                this.setState({
                    transactionTypesByAfm: response.value.data
                })
            },
            (error) => {
            }
        );
    }

    defineInitialPaymentTypeValue(hasEcomTransactions, hasNotEcomTransactions, initialCheck) {
        if (initialCheck) {
            if (hasNotEcomTransactions) {
                return 'notecom'
            } else if (hasEcomTransactions) {
                return 'ecom'
            } else if (this.state.capabilities.isCardlinkOne) {
                return 'installments'
            } else if (this.state.capabilities.hasCardless) {
                return 'cardless'
            } else {
                return 'notecom'
            }
        } else {
            return this.state.paymentTypeValue
        }
    }

    setSelectedTab(key) {
        this.setState({
            paymentTypeValue: key
        })
    }

    handleChange(key, value) {
        // Handle both direct key-value calls and event-based calls
        if (typeof key === 'object' && key.target) {
            // Event-based call
            this.setState({
                [key.target.id]: key.target.value
            });
        } else {
            // Direct key-value call
            this.setState({
                [key]: value
            });
        }
    }

    adjustTable(page, sizePerPage, sortField, sortOrder) {
        this.getTransactions(
            this.state.dateFrom,
            this.state.dateTo,
            this.state.startTime,
            this.state.endTime,
            page,
            sizePerPage,
            false,
            sortField,
            sortOrder,
            this.state.paymentTypeValue,
            this.state.cardNumber,
            this.state.rrn,
            this.state.authorizationCode,
            this.state.merchantId,
            this.state.terminalId,
            this.state.amountFrom,
            this.state.amountTo,
            this.state.acquirerId,
            this.state.vMerchantId,
            this.state.vTerminalId,
            this.state.transactionType,
            this.state.successStatus,
            this.state.rejectStatus,
            this.state.packageStatus,
            this.state.transactionTypeLabel,
            this.state.paymentTypeLabel,
            this.state.acquirerTypeLabel,
            this.state.showDuplicateTransactions
        )
    }

    adjustInstallmentsTable(page, sizePerPage, sortField, sortOrder) {
        this.getInstallments(
            this.state.trxId,
            this.state.dateFrom,
            this.state.dateTo,
            this.state.amountFrom,
            this.state.amountTo,
            page,
            sizePerPage,
            false,
            sortField,
            sortOrder
        )
    }

    adjustCardlessTable(page, sizePerPage, sortField, sortOrder) {
        this.getCardless(
            this.state.dateFrom,
            this.state.dateTo,
            this.state.startTime,
            this.state.endTime,
            this.state.amountFrom,
            this.state.amountTo,
            this.state.source,
            this.state.merchantId,
            this.state.paymentRespMessage,
            page,
            sizePerPage,
            false,
            sortField,
            sortOrder
        )
    }

    getRequiredMaps() {
        store.dispatch(getMap('transactionMaps')).then((response) => {
                this.setState({
                    allMaps: response.value.data
                })
            },
            (error) => {
            }
        );
    }

    formatData(data) {
        let colors = ["#ffffff", "#CECDCC"];
        let colorInx = 0;
        let currentDuplicateId = null;
        data.forEach((obj, idx) => {
            obj.dateAndTime = [obj.authorizationDate, obj.authorizationTime];
            obj.cardTypeAndNumber = [obj.cardTypeBrand, obj.maskedCardNumber];
            obj.authorizationAmount = getSignedAmount(obj.authorizationAmount, obj.amountSign)
            if (this.state.showDuplicateTransactions && obj.duplicateId !== null) {
                if (currentDuplicateId !== obj.duplicateId) {
                    colorInx = (colorInx + 1) % 2
                    currentDuplicateId = obj.duplicateId
                }
                obj.color = {"backgroundColor": colors[colorInx]}
            } else {
                obj.color = {"backgroundColor": "#ffffff"}
            }
        });        return data;
    }

    getTransactions(dateFrom, dateTo, startTime, endTime, page, rowsPerPage, fromSearch, by, asc, paymentTypeValue, cardNumber, rrn, authorizationCode, merchantId, terminalId, amountFrom, amountTo, acquirerId, vMerchantId, vTerminalId, transactionType, successStatus, rejectStatus, packageStatus, transactionTypeLabel, paymentTypeLabel, acquirerTypeLabel, showDuplicateTransactions) {

        let responseCode = (successStatus && !rejectStatus) ? 'approved' : (rejectStatus && !successStatus) ? 'declined' : undefined;

        if (fromSearch === true) {
            // It is the correspoding api field for 'transaction status'
            dateFrom = moment(dateFrom).format('DD/MM/YYYY')
            dateTo = moment(dateTo).format('DD/MM/YYYY')
            startTime = moment(startTime).format('HH:mm')
            endTime = moment(endTime).format('HH:mm')
            merchantId = merchantId ? merchantId : null
            terminalId = terminalId ? terminalId.value : null
            vMerchantId = vMerchantId ? vMerchantId.value : null
            vTerminalId = vTerminalId ? vTerminalId.value : null
            by = "authorizationDate,authorizationTime";
            this.setState({
                dateFrom: dateFrom,
                dateTo: dateTo,
                startTime: startTime,
                endTime: endTime,
                page: page,
                rowsPerPage: rowsPerPage,
                cardNumber: cardNumber,
                by: by,
                rrn: rrn,
                authorizationCode: authorizationCode,
                responseCode: responseCode,
                merchantId: merchantId,
                terminalId: terminalId,
                amountFrom: amountFrom,
                amountTo: amountTo,
                acquirerId: acquirerId,
                vMerchantId: vMerchantId,
                vTerminalId: vTerminalId,
                transactionType: transactionType,
                transactionTypeLabel: transactionTypeLabel,
                successStatus: successStatus,
                rejectStatus: rejectStatus,
                packageStatus: packageStatus,
                paymentTypeValue: paymentTypeValue,
                acquirerTypeLabel: acquirerTypeLabel,
                paymentTypeLabel: paymentTypeLabel,
                showDuplicateTransactions: showDuplicateTransactions
            })
        }

        if (fromSearch && (by === undefined || by === null)) {
            by = this.state.by;
            asc = this.state.asc;
        }

        if (!fromSearch) {
            this.setState({
                currentPage: page,
                rowsPerPage: rowsPerPage,
                asc: asc,
                by: by,
                fromSearch: fromSearch
            })
        }

        by = (showDuplicateTransactions && fromSearch ? "duplicate_id," : "") + by

        store.dispatch(getTransactionList(this.state.userAfm, dateFrom, dateTo, startTime, endTime, page, rowsPerPage, cardNumber, rrn, authorizationCode, merchantId, terminalId, amountFrom, amountTo, acquirerId, vMerchantId, vTerminalId, transactionType, responseCode, packageStatus, paymentTypeValue, by, asc, showDuplicateTransactions)).then(
            (response) => {
                const data = this.formatData(response.value.data.payload.payload);
                this.setState({
                    tableData: data,
                    total: response.value.data.payload.total,
                    currentPage: page,
                    rowsPerPage: rowsPerPage,
                    by: by,
                    asc: asc,
                    fromSearch: fromSearch
                })
            },
            (error) => {
            }
        );
    }

    getInstallments(trxId, dateFrom, dateTo, amountFrom, amountTo, page, rowsPerPage, fromSearch, by, asc) {
        if (fromSearch === true) {
            // Format dates to DD/MM/YYYY format that the API expects
            dateFrom = moment(dateFrom).format('DD/MM/YYYY')
            dateTo = moment(dateTo).format('DD/MM/YYYY')
            by = "payment_date"
            this.setState({
                dateFrom: dateFrom,
                dateTo: dateTo,
                amountFrom: amountFrom,
                amountTo: amountTo,
                page: page,
                rowsPerPage: rowsPerPage,
                by: by,
                trxId: trxId
            })
        }

        if (fromSearch && (by === undefined || by === null)) {
            by = this.state.by;
            asc = this.state.asc;
        }

        if (!fromSearch) {
            this.setState({
                currentPage: page,
                rowsPerPage: rowsPerPage,
                asc: asc,
                by: by,
                trxId: trxId
            })
        }

        store.dispatch(getInstallmentsList(this.state.userAfm, trxId, dateFrom, dateTo, amountFrom, amountTo, page, rowsPerPage, by, asc)).then(
            (response) => {
                const data = response.value.data.payload.payload.map(obj => ({
                    ...obj,
                    amount: getSignedAmount(obj.amount, obj.amountSign),
                    statusId: I18n.t('pages.installments.details.statusDescription.' + obj.statusId)
                }));
                this.setState({
                    installmentsTableData: data,
                    total: response.value.data.payload.total,
                    currentPage: page,
                    rowsPerPage: rowsPerPage,
                    by: by,
                    asc: asc,
                    fromSearch: fromSearch
                })
            },
            (error) => {
            })
    }

    getCardless (dateFrom, dateTo, startTime, endTime, amountFrom, amountTo, source, merchantId, paymentRespMessage, page, rowsPerPage, fromSearch, by, asc) {
        if (fromSearch === true) {
            // Format dates to DD/MM/YYYY format and times to HH:mm format that the API expects
            dateFrom = moment(dateFrom).format('DD/MM/YYYY')
            dateTo = moment(dateTo).format('DD/MM/YYYY')
            startTime = moment(startTime).format('HH:mm')
            endTime = moment(endTime).format('HH:mm')
            merchantId = merchantId ? merchantId : null
            by = "payment_date"
            this.setState({
                dateFrom: dateFrom,
                dateTo: dateTo,
                startTime: startTime,
                endTime: endTime,
                amountFrom: amountFrom,
                amountTo: amountTo,
                source: source,
                merchantId: merchantId,
                paymentRespMessage: paymentRespMessage,
                page: page,
                rowsPerPage: rowsPerPage,
                by: by
            })
        }

        if (fromSearch && (by === undefined || by === null)) {
            by = this.state.by;
            asc = this.state.asc;
        }

        if (!fromSearch) {
            this.setState({
                currentPage: page,
                rowsPerPage: rowsPerPage,
                asc: asc,
                by: by
            })
        }

        store.dispatch(getCardlessList(this.state.userAfm, dateFrom, dateTo, startTime, endTime, amountFrom, amountTo, source, merchantId, paymentRespMessage, page, rowsPerPage, by, asc)).then(
            (response) => {
                const data = response.value.data.payload.payload.map(obj => ({
                    ...obj,
                    dateAndTime: obj.dateAndTime = [obj.authorizationDate, obj.authorizationTime],
                    amount: getSignedAmount(obj.amount, obj.amountSign),
                    paymentRespMessage: {
                        text: obj?.paymentRespMessage ? I18n.t(`pages.cardless.details.statusDescription.${parseInt(obj.paymentRespMessage)}`) : '-',
                        code: obj?.paymentRespMessage ? parseInt(obj.paymentRespMessage) : null,
                        isSuccess: this.state.allMaps.cardless.status[parseInt(obj.paymentRespMessage)]?.isSuccess
                    },
                    source: this.state.allMaps.cardless.source.find(entry => entry.value === obj.source)?.label || null
                }));
                this.setState({
                    cardlessTableData: data,
                    total: response.value.data.payload.total,
                    currentPage: page,
                    rowsPerPage: rowsPerPage,
                    by: by,
                    asc: asc,
                    fromSearch: fromSearch
                })
            },
            (error) => {
            })
    }

    downloadTransactionsReport() {
        const currentUrl = window.location.origin
        this.setState({
            loaderSquircleIsActive: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    loaderSquircleIsActive: false
                });
            }, 5000)
        });

        if (this.state.paymentTypeValue === 'installments') {
            store.dispatch(downloadInstallmentsReport(this.state.userAfm, this.state.trxId, this.state.dateFrom, this.state.dateTo, this.state.amountFrom, this.state.amountTo, 1, -1, this.state.by, this.state.asc, this.props.userReducer.impersonator !== null ? this.props.userReducer.impersonator.email : this.props.userReducer.profile.email,
                currentUrl, this.props.userReducer.impersonator !== null)).then(() => {
                },
                (error) => {
                    if (error.response.status === 413) {
                        this.setState({
                            transactionReportError: 'pages.transactions.excelReport.largeAmountOfDataError'
                        });
                    }
                })
        } else if (this.state.paymentTypeValue === 'cardless') {
            store.dispatch(downloadCardlessReport(this.state.userAfm, this.state.dateFrom, this.state.dateTo,
                                                  this.state.startTime, this.state.endTime,
                                                  this.state.amountFrom, this.state.amountTo,
                                                  this.state.source, this.state.merchantId,
                                                  this.state.paymentRespMessage, 1, -1,
                                                  this.state.by, this.state.asc,
            this.props.userReducer.impersonator !== null ? this.props.userReducer.impersonator.email : this.props.userReducer.profile.email,
                currentUrl, this.props.userReducer.impersonator !== null)).then(() => {
                },
                (error) => {
                    if (error.response.status === 413) {
                        this.setState({
                            transactionReportError: 'pages.transactions.excelReport.largeAmountOfDataError'
                        });
                    }
                })
        } else {
            store.dispatch(downloadTransactionReport(this.state.userAfm, this.state.dateFrom, this.state.dateTo, this.state.startTime,
                this.state.endTime, 1, -1, this.props.i18n.locale,
                this.state.cardNumber, this.state.rrn, this.state.authorizationCode,
                this.state.merchantId, this.state.terminalId, this.state.amountFrom, this.state.amountTo,
                this.state.acquirerId, this.state.vMerchantId, this.state.vTerminalId, this.state.transactionType,
                this.state.responseCode, this.state.packageStatus, this.state.paymentTypeValue, this.state.by,
                this.state.asc, this.state.showDuplicateTransactions,
                this.props.userReducer.impersonator !== null ? this.props.userReducer.impersonator.email : this.props.userReducer.profile.email,
                currentUrl, this.props.userReducer.impersonator !== null)).then(() => {
                },
                (error) => {
                    if (error.response.status === 413) {
                        this.setState({
                            transactionReportError: 'pages.transactions.excelReport.largeAmountOfDataError'
                        });
                    }
                })
        }
    }
    allResultsDropdowns(response) {
        // Only proceed if response and getAssociationsResponse exist
        if (!response || !response.getAssociationsResponse) {
            console.warn('allResultsDropdowns called with invalid response:', response);
            return;
        }

        let midsInDropdownFormat = this.state.filteredMids ?
            this.toDropdownFormat(this.state.filteredMids, 'pickedMid')
            : this.toDropdownFormat(response.getAssociationsResponse.uniqueMidsWithLocation, 'pickedMid');
        let tidsInDropdownFormat = this.state.filteredTids ?
            this.toDropdownFormat(this.state.filteredTids, 'pickedTid', 'allPosBaseTid')
            : this.toDropdownFormat(response.getAssociationsResponse.uniqueTids, 'pickedTid', 'allPosBaseTid');
        let vMidsInDropdownFormat = this.state.filteredVMids ?
            this.toDropdownFormat(this.state.filteredVMids, 'pickedVMid', 'allPosBaseVmid')
            : this.toDropdownFormat(response.getAssociationsResponse.uniqueVMids, 'pickedVMid', 'allPosBaseVmid');
        let vTidsInDropdownFormat = this.state.filteredVTids ?
            this.toDropdownFormat(this.state.filteredVTids, 'pickedVTid', 'allPosBaseVtid')
            : this.toDropdownFormat(response.getAssociationsResponse.uniqueVTids, 'pickedVTid', 'allPosBaseVtid');        this.setState({
            nonMapData: {
                midsInDropdownFormat: midsInDropdownFormat,
                tidsInDropdownFormat: tidsInDropdownFormat,
                vMidsInDropdownFormat: vMidsInDropdownFormat,
                vTidsInDropdownFormat: vTidsInDropdownFormat
            }
        })
    }

    toDropdownFormat(arr, id, state) {
        // Add null check for arr parameter
        if (!arr || !Array.isArray(arr)) {
            return [];
        }

        let result = arr.map(element => {
            // Add null/undefined check for element
            if (!element) {
                return null;
            }

            if (id === 'pickedMid' && element.mid) {
                let label = element.location ? element.mid.concat(" - ", element.location) : element.mid;
                label = filterByKeyValue(this.state.aliasesArr, element.mid) ? label + " - " + filterByKeyValue(this.state.aliasesArr, element.mid) : label;
                return {value: element.mid, label: label}
            }

            return {value: element, label: element, id: id}
        }).filter(Boolean); // Remove null/undefined elements

        if (id !== 'pickedMid') {
            result.unshift({value: undefined, label: this.state[state], id: id});
        }
        result.forEach((obj, idx) => {
            if (id === 'pickedTid') {
                obj.label = filterByKeyValue(this.state.aliasesArr, obj.value) ? obj.label + " - " + filterByKeyValue(this.state.aliasesArr, obj.value) : obj.label;
            }
            if ((obj.value === null || obj.value === "") && (obj.label === null || obj.label === "")) {
                result.splice(idx, 1);
            }
        });
        return result;
    }

    setAliasesArr(afm) {
        store.dispatch(getMidsTidsWithAliases(afm, undefined)).then((response) => {
            this.setState({
                aliasesArr: response.value.data
            })
        })
    }

    hideTransactionReportError() {
        this.setState({
            transactionReportError: null
        })
    }

    toggleMoreCriteria(value) {
        this.setState({
            moreCriteria: value
        })
    }

    render() {
        const availableTransactionTypes = this.getAvailableTransactionTypes();
        const hasAnyTransactionType = availableTransactionTypes.length > 0;

        // Required to know which of 2 tabs to render
        // The possible values of 'paymentTypeValue' are more than 'ecom' or 'notecom' so must be mapped accordingly
        // to these two
        this.defineInitialPaymentTypeValue(this.state.capabilities.hasEcomTransactions, this.state.capabilities.hasNotEcomTransactions);

        return (
            this.props.userReducer.getAssociationsResponse.uniqueAfmsWithTitles.length > 0 ?
                <main className={"main-page transactions-page"
                    + (this.state.moreCriteria ? " more-criteria" : "")
                    + (this.state.toggleStates.isNoteToggleOn ? " note-open" : "")
                    + (this.state.toggleStates.isEcomToggleOn ? " ecom-open" : "")
                    + (this.state.toggleStates.isInstallmentsToggleOn ? " installments-open" : "")
                    + (this.state.toggleStates.isCardlessToggleOn ? " cardless-open" : "")
                    + ((this.state.paymentTypeValue === 'notecom' || this.state.paymentTypeValue === 'ecom') && this.state.tableData?.length > 0 ? " table-with-data" : "")
                    + (this.state.paymentTypeValue === 'installments' && this.state.installmentsTableData?.length > 0 ? " table-with-data" : "")
                    + (this.state.paymentTypeValue === 'cardless' && this.state.cardlessTableData?.length > 0 ? " table-with-data" : "")
                }>
                    <div className="transactions">
                        <div id="controlled-tabs-transactions">
                            {this.props.merchantReducer.ecomAvailability.fetched ?
                                <Tabs activeKey={this.getSelectedTabKey()}
                                      onSelect={(paymentTypeValue) => {
                                          const selectedType = TRANSACTION_TYPES[paymentTypeValue];
                                          const isInstallments = selectedType && selectedType.isInstallment;
                                          const isCardless = selectedType && selectedType.isCardless;

                                          this.setState({
                                              paymentTypeValue: paymentTypeValue,
                                              paymentTypeLabel: null,
                                              currentPage: 1,
                                              rowsPerPage: 20,
                                              dateFrom: moment().format('DD/MM/YYYY'),
                                              dateTo: moment().format('DD/MM/YYYY'),
                                              startTime: "00:00",
                                              endTime: "23:59",
                                              cardNumber: '',
                                              rrn: '',
                                              authorizationCode: '',
                                              merchantId: undefined,
                                              terminalId: '',
                                              amountFrom: '',
                                              amountTo: '',
                                              source: '',
                                              acquirerId: undefined,
                                              acquirerTypeLabel: null,
                                              vMerchantId: undefined,
                                              vTerminalId: undefined,
                                              transactionType: undefined,
                                              transactionTypeLabel: '',
                                              successStatus: false,
                                              rejectStatus: false,
                                              packageStatus: null,
                                              asc: false,
                                              by: isInstallments ? "payment_date" : (isCardless ? "authorization_date,authorization_time": "authorizationDate,authorizationTime"),
                                              showDuplicateTransactions: false
                                          }, () => {
                                              if (isInstallments) {
                                                  this.getInstallments(
                                                      this.state.trxId,
                                                      this.state.dateFrom,
                                                      this.state.dateTo,
                                                      this.state.amountFrom,
                                                      this.state.amountTo,
                                                      this.state.currentPage,
                                                      this.state.rowsPerPage,
                                                      false,
                                                      this.state.by,
                                                      this.state.asc
                                                  )
                                              } else if (isCardless) {
                                                  this.getCardless(
                                                      this.state.dateFrom,
                                                      this.state.dateTo,
                                                      this.state.startTime,
                                                      this.state.endTime,
                                                      this.state.amountFrom,
                                                      this.state.amountTo,
                                                      this.state.source,
                                                      this.state.merchantId,
                                                      this.state.paymentRespMessage,
                                                      this.state.currentPage,
                                                      this.state.rowsPerPage,
                                                      false,
                                                      this.state.by,
                                                      this.state.asc,
                                                  )
                                              } else {
                                                  this.getTransactions(
                                                      this.state.dateFrom,
                                                      this.state.dateTo,
                                                      this.state.startTime,
                                                      this.state.endTime,
                                                      this.state.currentPage,
                                                      this.state.rowsPerPage,
                                                      false,
                                                      this.state.by,
                                                      this.state.asc,
                                                      this.state.paymentTypeValue,
                                                      this.state.cardNumber,
                                                      this.state.rrn,
                                                      this.state.authorizationCode,
                                                      this.state.merchantId,
                                                      this.state.terminalId,
                                                      this.state.amountFrom,
                                                      this.state.amountTo,
                                                      this.state.acquirerId,
                                                      this.state.vMerchantId,
                                                      this.state.vTerminalId,
                                                      this.state.transactionType,
                                                      this.state.successStatus,
                                                      this.state.rejectStatus,
                                                      this.state.packageStatus,
                                                      this.state.transactionTypeLabel,
                                                      this.state.pickedAcquirerLabel,
                                                      this.state.paymentTypeLabel,
                                                      this.state.showDuplicateTransactions
                                                  )
                                              }
                                              this.resetPopover();
                                          })
                                      }}>
                                    {availableTransactionTypes.map(transactionType =>
                                        this.renderTransactionTab(transactionType)
                                    )}
                                </Tabs>
                                :
                                this.props.merchantReducer.ecomAvailability.fetching ?
                                    <Loader bouncing={true}
                                            color={'cerulean'}
                                            message=''
                                            subMessage=''
                                            loaderStyles={{minHeight: "120px", top: "80px", position: "absolute"}}/>:null}
                            {this.state.loaderSquircleIsActive ?
                                <Loader bouncing={true}
                                        color={'cerulean'}
                                        loaderStyles={{minHeight: "100vh", margin: "0"}}
                                        message='loader.trxEmail'
                                        subMessage='loader.trxSubMessage'
                                        style={{top: "115px"}}
                                        overlayClass="is-overlay"/> : null
                            }
                        </div>
                    </div>
                </main> :
                <div className="no-pos__wrapper">
                    <EmptyStateShape title="common.noPosInAccount" />
                </div>
        )
    }
}

export default connect(stateMap)(Transactions);
